import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { reactive, watch, ref } from 'vue';
import { useFormChanged } from '@/hooks';
import { XEditorLayout } from '@/components';
import { KpiValueInput, modal } from '@/share/components';
import { omit } from '@/utils';

import { useComponentModalInstance } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/share/hooks/common/index.js';
import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'kpi-item-editor-form',
  props: {
    id: {
      type: String,
      default: ''
    },
    projId: {
      type: String,
      default: ''
    },
    parentId: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 0
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const formRef = ref();
    const modalInst = useComponentModalInstance();
    const props = __props;
    const formData = reactive({
      name: '',
      compareMode: 2,
      // 非量化指标
      value: 0,
      nValue: '',
      unit: '',
      explain: '',
      summary: '',
      code: '',
      std: '计划标准',
      basis: '',
      scoreStd: '',
      order: 0,
      classify: 0,
      kpiValue: {
        compareMode: 0,
        value: 0,
        nValue: ''
      }
    });
    const rules = reactive({
      name: [{
        trigger: 'blur',
        required: true,
        message: '指标分类名称不能为空'
      }],
      std: [{
        trigger: 'blur',
        required: true,
        message: '绩效标准不能为空'
      }],
      kpiValue: [{
        trigger: 'blur',
        validator: (_, val) => {
          const {
            compareMode = 0,
            nValue = '',
            unit = ''
          } = val;
          if (compareMode === 0) return Promise.reject(new Error('请选择指标值比较方式'));
          if (compareMode >= 3 && compareMode <= 8 && !unit) {
            return Promise.reject(new Error('计量单位不能为空'));
          } else if (compareMode === 2 && !nValue) {
            return Promise.reject(new Error('指标值不能为空'));
          }
          return Promise.resolve();
        }
      }]
    });
    const oldFormData = reactive({});
    watch(() => formData.kpiValue, val => {
      const {
        compareMode = 0,
        nValue = '',
        value = 0,
        unit = ''
      } = val || {};
      Object.assign(formData, {
        compareMode,
        value,
        nValue,
        unit
      });
    }, {
      deep: true
    });
    const parentInfo = reactive({
      name: ''
    });
    const {
      runAsync: getParentProjKpiItemDetail
    } = fetchApi('kpi.projKpiItem.getDetail');
    const parentId = ref(props.parentId);
    const loadParentInfo = async id => {
      if (!id) {
        parentInfo.name = '顶层指标';
        return;
      }
      const {
        error,
        ...res
      } = await getParentProjKpiItemDetail({
        id
      });
      if (error) return;
      const {
        classify = 0
      } = res;
      formData.classify = classify;
      Object.assign(parentInfo, res);
    };
    watch(() => props.parentId, val => {
      parentId.value = val;
    }, {
      immediate: true
    });
    watch(parentId, val => {
      loadParentInfo(val);
    }, {
      immediate: true
    });
    const {
      isChanged,
      reset
    } = useFormChanged(oldFormData, formData);
    const {
      loading,
      error,
      runAsync: getProjKpiItemDetail
    } = fetchApi('kpi.projKpiItem.getDetail');
    const {
      loading: saveLoading,
      runAsync: saveProjKpiItem
    } = fetchApi('kpi.projKpiItem.save');
    const loadDetail = async id => {
      if (!id) return;
      const {
        error,
        ...res
      } = await getProjKpiItemDetail({
        id
      });
      if (error) return;
      parentId.value = res.parentId || '';
      const data = {
        ...res,
        kpiValue: {
          compareMode: res.compareMode || 0,
          value: res.value || 0,
          nValue: res.nValue || '',
          unit: res.unit || ''
        }
      };
      Object.assign(oldFormData, data);
      Object.assign(formData, data);
      reset();
    };
    watch([isChanged, saveLoading], val => {
      const [b1, b2] = val;
      modalInst.setConfirmButton({
        disabled: !b1,
        loading: b2
      });
    });
    watch(() => props.id, val => {
      loadDetail(val);
    }, {
      immediate: true
    });
    const save = async () => {
      const valid = await formRef.value.validate();
      if (!valid) return false;
      const {
        error
      } = await saveProjKpiItem({
        ...formData,
        ...omit({
          id: props.id,
          parentId: props.parentId,
          projId: props.projId,
          level: props.level
        })
      });
      if (error) return false;
      modal.notification.success(`保存指标项分类${formData.name}成功`, '保存指标项');
      return true;
    };
    const onOk = async () => {
      return await save();
    };
    const onCancel = async () => {};
    __expose({
      confirmListener: onOk,
      cancelListener: onCancel,
      save
    });
    return (_ctx, _cache) => {
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_col = _resolveComponent("a-col");
      const _component_a_row = _resolveComponent("a-row");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_textarea = _resolveComponent("a-textarea");
      return _openBlock(), _createBlock(_unref(XEditorLayout), {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        rules: rules,
        loading: _unref(loading),
        error: _unref(error)
      }, {
        default: _withCtx(() => [_createVNode(_component_a_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "指标分类",
              name: "classify"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(['未分类', '产出指标', '效益指标', '满意度指标'][formData.classify] || '未分类'), 1)]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "分类路径",
              name: "namePath"
            }, {
              default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(parentInfo.name), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "指标编码",
              name: "code"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.code,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => formData.code = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "指标名称",
              name: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input, {
                value: formData.name,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.name = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_row, {
          gutter: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "指标值",
              name: "kpiValue"
            }, {
              default: _withCtx(() => [_createVNode(_unref(KpiValueInput), {
                value: formData.kpiValue,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.kpiValue = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "排序",
              name: "order"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_input_number, {
                value: formData.order,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.order = $event)
              }, null, 8, ["value"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "指标值说明",
          name: "summary"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: formData.summary,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.summary = $event),
            "auto-size": {
              minRows: 2,
              maxRows: 4
            }
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          label: "指标解释",
          name: "explain"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_textarea, {
            value: formData.explain,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => formData.explain = $event),
            "auto-size": {
              minRows: 2,
              maxRows: 4
            }
          }, null, 8, ["value"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "loading", "error"]);
    };
  }
};